var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settings-emails-templates-form" },
    [
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "email.SettingsEmailsTemplatesForm.label_template_name"
            ),
            error: _vm.errorLabelTemplateName,
            required: "",
            requiredLabel: _vm.$t.__("common.labels.required")
          }
        },
        [
          _c("CompassInput", {
            attrs: {
              error: !!_vm.errorLabelTemplateName,
              placeholder: _vm.$t.__(
                "email.SettingsEmailsTemplatesForm.placeholder_template_name"
              )
            },
            on: {
              input: _vm.checkLimitTemplateName,
              focus: _vm.checkLimitTemplateName,
              keypress: _vm.checkTypingTemplateName
            },
            model: {
              value: _vm.templateName,
              callback: function($$v) {
                _vm.templateName = $$v
              },
              expression: "templateName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("RichText", {
        ref: "refSettingsEmailsTemplatesFormRichTextSubject",
        staticClass: "settings-emails-templates-form__richtext-subject",
        attrs: {
          refRichText: "refSettingsEmailsTemplatesFormRichTextSubject",
          formitem: _vm.formItemSujectRichText,
          placeholder: _vm.$t.__(
            "email.SettingsEmailsTemplatesForm.placeholder_subject"
          ),
          options: _vm.optionsSubjectRichText,
          disableEnter: ""
        },
        model: {
          value: _vm.templateSubject,
          callback: function($$v) {
            _vm.templateSubject = $$v
          },
          expression: "templateSubject"
        }
      }),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.formItemMessageRichText.label,
            error: _vm.formItemMessageRichText.error,
            required: "",
            requiredLabel: _vm.$t.__("common.labels.required")
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "settings-emails-templates-form__message",
              class: _vm.messageClass
            },
            [
              _c("RichText", {
                ref: "refSettingsEmailsTemplatesFormRichTextMessage",
                staticClass: "settings-emails-templates-form__richtext-message",
                attrs: {
                  refRichText: "refSettingsEmailsTemplatesFormRichTextMessage",
                  placeholder: _vm.$t.__(
                    "email.SettingsEmailsTemplatesForm.placeholder_message_email"
                  ),
                  options: _vm.optionsMessageRichText,
                  typeRichText: "email",
                  showRichTextMenu: false,
                  hash: _vm.getHashMessage,
                  showAIComponents: _vm.isSellsyAIEnabled
                },
                on: {
                  focus: function($event) {
                    return _vm.setIsEditorFocused(true)
                  },
                  blur: function($event) {
                    return _vm.setIsEditorFocused(false)
                  }
                },
                model: {
                  value: _vm.templateMessage,
                  callback: function($$v) {
                    _vm.templateMessage = $$v
                  },
                  expression: "templateMessage"
                }
              }),
              _vm._v(" "),
              _vm.attachments.length
                ? _c(
                    "div",
                    {
                      staticClass: "settings-emails-templates-form__attachments"
                    },
                    _vm._l(_vm.attachments, function(item, index) {
                      return _c("EmailAttachments", {
                        key: index,
                        attrs: { attachment: item },
                        on: { removeItem: _vm.removeAttachment }
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.richTextEditor
                ? _c("RichTextMenu", {
                    staticClass: "email-richtext-menu",
                    attrs: {
                      editorMenu: _vm.richTextEditor,
                      options: _vm.optionsMessageRichText,
                      typeRichText: "email",
                      hash: _vm.getHashMessage,
                      refRichText:
                        "refSettingsEmailsTemplatesFormRichTextMessage",
                      attachmentEndpoint: "/email/templates/files"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }